import {
  Alert,
  Button,
  FormHelperText,
  Grid,
  OutlinedInput,
  Step,
  StepLabel,
  Stepper,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography
} from '@mui/material';
import IconButton from '../../../components/@extended/IconButton';
import { CloseOutlined, InfoCircleFilled } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import MainCard from '../../../components/MainCard';
import { useTheme } from '@mui/material/styles';
import { StepWrapper } from './AddSlaveForm';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  input: {
    '&:hover $notchedOutline': {
      borderColor: theme.palette.grey[300]
    }
  },
  notchedOutline: {}
}));

type Prop = {
  handleClose: () => void;
  handleSuccess: (riskType: 'percentage' | 'lot' | 'fixedLot' | '' | null, value: string) => void;
};

const RiskCalculatorModal = ({ handleClose, handleSuccess }: Prop) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [riskType, setRiskType] = useState<'percentage' | 'lot' | 'fixedLot' | '' | null>('');
  const [masterTradeRisk, setMasterTradeRisk] = useState('');
  const [masterTradeRiskError, setMasterTradeRiskError] = useState<null | string>(null);
  const [masterTradeRiskFocus, setMasterTradeRiskFocus] = useState<boolean>(false);
  const [fixedTradeRisk, setFixedTradeRisk] = useState('');
  const [fixedTradeRiskError, setFixedTradeRiskError] = useState<null | string>(null);
  const [fixedTradeRiskFocus, setFixedTradeRiskFocus] = useState<boolean>(false);
  const [slaveTradeRisk, setSlaveTradeRisk] = useState('');
  const [slaveTradeRiskError, setSlaveTradeRiskError] = useState<null | string>(null);
  const [slaveTradeRiskFocus, setSlaveTradeRiskFocus] = useState<boolean>(false);
  const classes = useStyles(theme);

  useEffect(() => {
    try {
      const val = parseFloat(slaveTradeRisk);
      console.log('', val, slaveTradeRiskFocus);
      if ((val < 0.01 || isNaN(val)) && slaveTradeRiskFocus) {
        setSlaveTradeRiskError('Slave trade risk should be positive');
      } else {
        setSlaveTradeRiskError(null);
      }
    } catch (e) {
      setSlaveTradeRiskError('Invalid slave trade risk value');
    }
  }, [slaveTradeRisk]);

  useEffect(() => {
    try {
      const val = parseFloat(masterTradeRisk);
      console.log('', val, masterTradeRiskFocus);
      if ((val < 0.01 || isNaN(val)) && masterTradeRiskFocus) {
        setMasterTradeRiskError('Master trade risk should be positive');
      } else {
        setMasterTradeRiskError(null);
      }
    } catch (e) {
      setMasterTradeRiskError('Invalid master trade risk value');
    }
  }, [masterTradeRisk]);

  useEffect(() => {
    try {
      const val = parseFloat(fixedTradeRisk);
      console.log('', val, fixedTradeRiskFocus);
      if ((val < 0.01 || isNaN(val)) && fixedTradeRiskFocus) {
        setFixedTradeRiskError('Fixed trade risk should be positive');
      } else {
        setFixedTradeRiskError(null);
      }
    } catch (e) {
      setFixedTradeRiskError('Invalid fixed trade risk value');
    }
  }, [fixedTradeRisk]);

  const checkIntType = (number: any) => {
    if (Math.round(number) === number) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    console.log('risk: ', riskType);
  }, [riskType]);

  return (
    <>
      <MainCard
        title={
          <Typography fontWeight={700} fontSize={16}>
            {activeStep === 0
              ? 'Select your Master risk type'
              : activeStep === 1
              ? 'How much do you risk per trade'
              : activeStep === 2
              ? 'How much do you wish to risk on your slave'
              : 'Your recommended risk settings'}
          </Typography>
        }
        secondary={
          <IconButton
            size="small"
            onClick={() => {
              handleClose();
            }}
          >
            <CloseOutlined />
          </IconButton>
        }
        sx={{ minHeight: 350 }}
      >
        {/*<Card
          elevation={0}
          sx={{
            p: 2,
            borderRadius: '4px',
            border: '1px solid',
            borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey.A800
          }}
        >
          <Grid item xs={12}>
            <Stepper hidden={true} nonLinear activeStep={activeStep}>
              {[
                'Select your master risk',
                'How much do you risk per trade',
                'How much do you wish to risk on your slave',
                'Your recommended risk settings'
              ].map((label, index) => (
                <Step key={label}>
                  <StepLabel color="inherit"></StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
        </Card>*/}

        <Grid item xs={12} sx={{ display: 'none' }}>
          <Stepper hidden={true} nonLinear activeStep={activeStep}>
            {[
              'Select your master risk',
              'How much do you risk per trade',
              'How much do you wish to risk on your slave',
              'Your recommended risk settings'
            ].map((label, index) => (
              <Step key={label}>
                <StepLabel color="inherit"></StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>

        <StepWrapper value={activeStep} index={0}>
          <Grid item sx={{ mb: 7, mt: -2 }}>
            <Alert color="primary" icon={<InfoCircleFilled />}>
              When you place a trade on your master account, do you calculate your position sizing using a % of the account balance, for
              example, 1% risk, or do you trade based on lot sizes, for example, 0.5 lots per trade?
            </Alert>
            <ToggleButtonGroup
              fullWidth
              value={riskType}
              exclusive
              onChange={(event, val) => setRiskType(val)}
              color="primary"
              aria-label="text alignment"
              size={'medium'}
              sx={{
                mt: 4,
                '& .MuiToggleButton-root': {
                  '&:not(.Mui-selected)': {
                    borderTopColor: theme.palette.secondary.main,
                    borderLeftColor: `${theme.palette.secondary.main}`,
                    borderRightColor: `${theme.palette.secondary.main}`,
                    borderBottomColor: theme.palette.secondary.main
                  },
                  '&:first-of-type': {
                    borderLeftColor: theme.palette.secondary.main
                  },
                  '&:last-of-type': {
                    borderRightColor: theme.palette.secondary.main
                  },
                  '&.Mui-selected': {
                    borderColor: `${theme.palette.primary.main} !important`,
                    borderLeftColor: `${theme.palette.primary.main} !important`,
                    borderRightColor: `${theme.palette.primary.main} !important`,
                    '&:hover': {
                      bgcolor: theme.palette.mode === 'light' ? '#EBF7F0' : '#05847829'
                    }
                  },
                  '&:hover': {
                    bgcolor: theme.palette.primary.lighter,
                    borderColor: theme.palette.primary.light,
                    // borderLeftColor: `${theme.palette.secondary.main} !important`,
                    zIndex: 2
                  }
                },
                '& .MuiToggleButtonGroup-root': {
                  '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                    marginLeft: '0px'
                  }
                }
              }}
            >
              <Tooltip
                title={
                  <Typography
                    color={theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color}
                    variant={'caption'}
                  >
                    You trade a % of your account balance
                  </Typography>
                }
              >
                <ToggleButton value="percentage" aria-label="first" selected={riskType === 'percentage'}>
                  % Based Risk
                </ToggleButton>
              </Tooltip>
              <Tooltip
                title={
                  <Typography
                    color={theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color}
                    variant={'caption'}
                  >
                    You trade based on lot sizes, sizes can change
                  </Typography>
                }
              >
                <ToggleButton value="lot" aria-label="second" selected={riskType === 'lot'}>
                  Lot Based Risk
                </ToggleButton>
              </Tooltip>
              <Tooltip
                title={
                  <Typography
                    color={theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color}
                    variant={'caption'}
                  >
                    You trade the same lot size on every trade
                  </Typography>
                }
              >
                <ToggleButton value="fixedLot" aria-label="third" selected={riskType === 'fixedLot'}>
                  Fixed Lot Risk
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          </Grid>
          <Grid item display="flex" justifyContent="end" alignItems="flex-start">
            <div style={{ marginRight: '8px' }}>
              <Button sx={{ paddingX: '24px' }} onClick={handleClose} disableElevation fullWidth variant="outlined" color="secondary">
                Close
              </Button>
            </div>
            <div>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => setActiveStep(1)}
                disabled={!riskType}
                disableElevation
                fullWidth
                variant="contained"
                color="primary"
              >
                Next
              </Button>
            </div>
          </Grid>
        </StepWrapper>

        <StepWrapper value={activeStep} index={1}>
          <Grid sx={{ mb: 8, mt: -2 }}>
            <Alert color="primary" icon={<InfoCircleFilled />}>
              {riskType === 'percentage'
                ? 'When you trade on your master, what % risk are you using? Note, this can fluctuate per trade, please enter starting % risk per trade.'
                : riskType === 'lot'
                ? 'When you trade on your master, how many lots are you placing? Note, this can fluctuate per trade, please enter starting lot size per trade.'
                : 'When you trade on your slave, how many lots do you wish to place per trade? This is a fixed lot value that will be entered on each position you open.'}
            </Alert>

            {riskType !== 'fixedLot' && (
              <Grid container direction="row" spacing={0} sx={{ mt: 4 }}>
                <Grid item xs={6}>
                  <OutlinedInput
                    fullWidth
                    id="end-adornment-master-trade-risk"
                    placeholder="Master trade risk"
                    value={masterTradeRisk}
                    type={'number'}
                    onChange={(event) => {
                      setMasterTradeRisk(event.target.value);
                    }}
                    onFocus={() => setMasterTradeRiskFocus(true)}
                    error={Boolean(masterTradeRiskError !== null && masterTradeRiskFocus)}
                    endAdornment={riskType === 'percentage' ? '%' : riskType === 'lot' ? 'lots' : ''}
                    sx={{
                      borderBottomRightRadius: '0px',
                      borderTopRightRadius: '0px',
                      backgroundColor: theme.palette.mode === 'light' ? '#EBF7F5' : '#05847829'
                    }}
                  />
                  {masterTradeRiskError && (
                    <FormHelperText error id="helper-text-end-adornment-master-trade-risk">
                      {masterTradeRiskError}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <OutlinedInput
                    fullWidth
                    disabled
                    readOnly
                    id="end-adornment-slave-trade-risk"
                    placeholder="Slave trade risk"
                    type={'number'}
                    value={slaveTradeRisk}
                    endAdornment={riskType === 'percentage' ? '%' : riskType === 'lot' ? 'lots' : ''}
                    sx={{
                      borderBottomLeftRadius: '0px',
                      borderTopLeftRadius: '0px'
                    }}
                    classes={{
                      root: classes.input,
                      notchedOutline: classes.notchedOutline
                    }}
                  />
                </Grid>
              </Grid>
            )}

            {riskType === 'fixedLot' && (
              <Grid container direction="row" spacing={0} sx={{ mt: 4 }}>
                <Grid item xs={6}>
                  <OutlinedInput
                    fullWidth
                    id="end-adornment-master-trade-risk"
                    placeholder="Fixed Trade risk"
                    value={fixedTradeRisk}
                    type={'number'}
                    onFocus={() => setFixedTradeRiskFocus(true)}
                    error={Boolean(fixedTradeRiskError !== null && fixedTradeRiskFocus)}
                    onChange={(event) => {
                      setFixedTradeRisk(event.target.value);
                    }}
                    sx={{ backgroundColor: theme.palette.mode === 'light' ? '#EBF7F5' : '#05847829' }}
                  />
                  {fixedTradeRiskError && (
                    <FormHelperText error id="helper-text-end-adornment-fixed-trade-risk">
                      {fixedTradeRiskError}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
            )}

            {/*<OutlinedInput
              id="end-adornment-master-trade-risk"
              placeholder="Master trade risk"
              value={masterTradeRisk}
              type={'number'}
              onChange={(event) => {
                setMasterTradeRisk(event.target.value);
              }}
              endAdornment={riskType === 'percentage' ? '%' : 'lots'}
              sx={{ mt: 2 }}
            />*/}
          </Grid>
          <Grid item display="flex" justifyContent="end" alignItems="flex-start">
            <div style={{ marginRight: '8px' }}>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => setActiveStep(0)}
                disableElevation
                fullWidth
                variant="outlined"
                color="secondary"
              >
                Back
              </Button>
            </div>
            <div>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => {
                  if (riskType === 'fixedLot') {
                    setActiveStep(3);
                  } else {
                    setActiveStep(2);
                  }
                }}
                disabled={
                  (riskType === 'fixedLot' && (!fixedTradeRisk || fixedTradeRiskError !== null)) ||
                  (riskType !== 'fixedLot' && (!masterTradeRisk || masterTradeRiskError !== null))
                }
                disableElevation
                fullWidth
                variant="contained"
                color="primary"
              >
                Next
              </Button>
            </div>
          </Grid>
        </StepWrapper>

        <StepWrapper value={activeStep} index={2}>
          <Grid item sx={{ mb: 8, mt: -2 }}>
            <Alert color="primary" icon={<InfoCircleFilled />}>
              {riskType === 'percentage'
                ? `If your master is trading ${masterTradeRisk}%, what % risk do you wish to place on your slave account?`
                : `If your master is trading ${masterTradeRisk} lots, how many lots do you wish to trade on your slave account?`}
            </Alert>

            <Grid container direction="row" spacing={0} sx={{ mt: 4 }}>
              <Grid item xs={6}>
                <OutlinedInput
                  fullWidth
                  disabled
                  readOnly
                  id="end-adornment-master-trade-risk"
                  placeholder="Master trade risk"
                  value={masterTradeRisk}
                  type={'number'}
                  endAdornment={riskType === 'percentage' ? '%' : riskType === 'lot' ? 'lots' : ''}
                  sx={{ borderBottomRightRadius: '0px', borderTopRightRadius: '0px' }}
                  classes={{
                    root: classes.input,
                    notchedOutline: classes.notchedOutline
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <OutlinedInput
                  fullWidth
                  id="end-adornment-slave-trade-risk"
                  placeholder="Slave trade risk"
                  type={'number'}
                  value={slaveTradeRisk}
                  onChange={(event) => {
                    setSlaveTradeRisk(event.target.value);
                  }}
                  onFocus={() => setSlaveTradeRiskFocus(true)}
                  error={Boolean(slaveTradeRiskError !== null && slaveTradeRiskFocus)}
                  endAdornment={riskType === 'percentage' ? '%' : riskType === 'lot' ? 'lots' : ''}
                  sx={{
                    borderBottomLeftRadius: '0px',
                    borderTopLeftRadius: '0px',
                    backgroundColor: theme.palette.mode === 'light' ? '#EBF7F5' : '#05847829'
                  }}
                />
                {slaveTradeRiskError && (
                  <FormHelperText error id="helper-text-end-adornment-slave-trade-risk">
                    {slaveTradeRiskError}
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item display="flex" justifyContent="end" alignItems="flex-start">
            <div style={{ marginRight: '8px' }}>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => setActiveStep(1)}
                disableElevation
                fullWidth
                variant="outlined"
                color="secondary"
              >
                Back
              </Button>
            </div>
            <div>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => setActiveStep(3)}
                disabled={!slaveTradeRisk || slaveTradeRiskError !== null}
                disableElevation
                fullWidth
                variant="contained"
                color="primary"
              >
                Next
              </Button>
            </div>
          </Grid>
        </StepWrapper>

        <StepWrapper value={activeStep} index={3}>
          <Grid item sx={{ mb: 16, mt: -2 }}>
            {riskType === 'fixedLot' && (
              <Alert color="primary" icon={<InfoCircleFilled />}>
                Based on the settings you have selected, we recommend that you trade with the Fixed Lot setting, with a {fixedTradeRisk} lot
                risk. Simply click below to apply these settings.
              </Alert>
            )}
            {riskType !== 'fixedLot' && (
              <Alert color="primary" icon={<InfoCircleFilled />}>
                Based on the options you have selected, we recommend that you trade with{' '}
                {riskType === 'percentage' ? 'Balance Multiplier' : 'Lot Multiplier'} with a risk setting of{' '}
                {checkIntType((+slaveTradeRisk / +masterTradeRisk) * 100)
                  ? (+slaveTradeRisk / +masterTradeRisk) * 100
                  : ((+slaveTradeRisk / +masterTradeRisk) * 100).toFixed(2)}
                %. Simply click below to apply these settings.
              </Alert>
            )}
          </Grid>
          <Grid item display="flex" justifyContent="end" alignItems="flex-start">
            <div style={{ marginRight: '8px' }}>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => {
                  if (riskType === 'fixedLot') {
                    setActiveStep(1);
                  } else {
                    setActiveStep(2);
                  }
                }}
                disableElevation
                fullWidth
                variant="outlined"
                color="secondary"
              >
                Back
              </Button>
            </div>
            <div>
              <Button
                sx={{ paddingX: '24px' }}
                onClick={() => {
                  if (riskType === 'fixedLot') {
                    handleSuccess(riskType, fixedTradeRisk);
                  } else {
                    const val = checkIntType((+slaveTradeRisk / +masterTradeRisk) * 100)
                      ? ((+slaveTradeRisk / +masterTradeRisk) * 100).toString()
                      : ((+slaveTradeRisk / +masterTradeRisk) * 100).toFixed(2);
                    handleSuccess(riskType, val);
                  }
                }}
                disableElevation
                fullWidth
                variant="contained"
                color="primary"
              >
                Apply
              </Button>
            </div>
          </Grid>
        </StepWrapper>
      </MainCard>
    </>
  );
};

export default RiskCalculatorModal;
